import React, { useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { localurl } from '../components/utils';
import { IoEyeOutline } from "react-icons/io5";
import { IoEyeOffOutline } from "react-icons/io5";

const Login = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const validationSchema = Yup.object({
        username: Yup.string().required(),
        password: Yup.string().min(4, 'Password must be at least 4 characters long').required('Password is required'),
    });

    const handleLogin = async (values) => {
        try {
            const response = await fetch(`${localurl}/signin/`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: `username=${encodeURIComponent(values.username)}&password=${encodeURIComponent(values.password)}`,
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(JSON.stringify(errorData));
            }
            const userData = await response.json();
            localStorage.setItem("token", userData.token);
            console.log("nevigat to TbDashboard")
            navigate("/dashboard");
            window.location.reload();
        } catch (error) {
            try {
                const errorData = JSON.parse(error.message);
                if (errorData.detail === "Inactive user") {
                    toast.error("Account Disabled or inactive. Contact admin");
                } else {
                    toast.error("Invalid credentials");
                }
            } catch (parseError) {
                toast.error("An unexpected error occurred");
            }
        }
    };

    return (
        <div className='flex flex-row justify-center items-center h-screen p-20 xs:p-5'>
            <div className='flex flex-col justify-center max-w-[500px]'>
                <div className='flex justify-center'>
                    <img src='/images/loginlogo.png' alt='logo' width="350px" />
                </div>
                <div className='border border-gray-200 rounded-3xl p-6 mt-6'>
                    <div className='flex justify-start my-8'>
                        <p className='text-3xl text-gray-600 font-medium'>Log in</p>
                    </div>
                    <Formik
                        initialValues={{ username: '', password: '', }}
                        validationSchema={validationSchema}
                        onSubmit={handleLogin}
                    >
                        {() => (
                            <Form>
                                <div>
                                    <div>
                                        <div className=' flex flex-col'>
                                            <label className='text-sm text-gray-500 font-normal'>User Name</label>
                                        </div>
                                        <Field type="text" name="username" className="border-2 border-gray-200 p-2  py-3 rounded-xl mt-1 w-full" />
                                        <ErrorMessage name="username" component="div" style={{ color: 'red' }} />
                                    </div>
                                    <div className='mt-5'>
                                        <div className=' flex flex-col'>
                                            <label className='text-sm text-gray-500 font-normal'>Password</label>
                                        </div>
                                        <div className='relative'>
                                            <Field type={showPassword ? "text" : "password"} name="password" className="border-2 border-gray-200 p-2 py-3 rounded-xl mt-1 w-full" />
                                            <span className='absolute z-30 cursor-pointer right-4 top-5' onClick={() => setShowPassword(!showPassword)}>
                                                {showPassword ? (<IoEyeOutline className='fill-gray-500 dark:fill-gray-400 size-5' />) : (<IoEyeOffOutline className='fill-gray-500 dark:fill-gray-400 size-5' />)}
                                            </span>
                                        </div>
                                        <ErrorMessage name="password" component="div" style={{ color: 'red' }} />
                                    </div>
                                    <div className='mt-2 flex gap-1'>
                                        <input type="checkbox" id="remember_me" />
                                        <label for="remember_me" className='text-sm'>Remember Me</label>
                                    </div>
                                    <div className=''>
                                        <p className='text-sm text-gray-700 mt-7'>By continuing, you agree to the <span className='underline cursor-pointer underline-offset-2 text-green'>Terms of use</span> and <span className='underline cursor-pointer underline-offset-2 text-green'>Privacy Policy</span>. </p>
                                    </div>
                                    <div>
                                        <button type="submit" className="p-4 w-full mt-3 text-white bg-green rounded-full">Login</button>
                                    </div>
                                    <div className='flex justify-center mt-3 underline underline-offset-2'>
                                        <p className='mt-3 cursor-pointer'>Forget your password</p>
                                    </div>
                                    {/* <div className='mt-5 flex justify-center'>
                                        <Link to="/signup" className='text-sm text-gray-600 font-normal'>Don’t have an account? <span className='text-sm text-green font-semibold underline underline-offset-2'>Sign up</span></Link>
                                    </div> */}
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
            <Toaster />
        </div>
    )
}

export default Login
